module.exports = __webpack_public_path__ + "img/box.0feaded0.png";